import { Base } from '@studiometa/js-toolkit';

/**
 * Neswletter.
 * 
 */

export default class NewsletterSticky extends Base {

    static config = {
        name: 'NewsletterSticky',
        refs: ['close'],
    }

    mounted() {
        this.$el.classList.add('newsletter-visible');
    }

    onCloseClick() {
        this.$el.classList.remove('newsletter-visible');
    }
}